module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/stack_add_graphic@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/stack_add_graphic@1x.png
// module id = 713
// module chunks = 0